import React from "react";
import ProviderLogo, { ProviderLogoSize } from "@/components/ProviderLogo";
import type { EntityIcon } from "./types";

export interface EntityIconSlotProps {
  /** Either a component or an image URL — the union `BreadcrumbItem.Icon` accepts. */
  icon?: EntityIcon;
  className: string;
  /**
   * Accessible name for an image icon. Omit for an icon that only decorates an
   * adjacent visible label, which also marks the slot `aria-hidden`.
   */
  label?: string;
  /** Box size for an image (provider) icon. */
  logoSize?: ProviderLogoSize;
}

/**
 * The one place that resolves an `EntityIcon` into markup.
 *
 * Both the switcher trigger and the switcher rows render the same union, so the
 * `typeof Icon === "string"` branch lives here rather than at each site — the
 * union has grown a member once already.
 */
const EntityIconSlot: React.FC<EntityIconSlotProps> = ({
  icon: Icon,
  className,
  label,
  logoSize = "sm",
}) => {
  if (!Icon) return null;
  return (
    <span className={className} aria-hidden={label ? undefined : "true"}>
      {typeof Icon === "string" ? (
        <ProviderLogo src={Icon} size={logoSize} label={label} />
      ) : (
        <Icon height={16} width={16} />
      )}
    </span>
  );
};

export default EntityIconSlot;
